import styled from 'styled-components';
import { Tree as BPTree } from '@blueprintjs/core';
var TreeLegacy = styled(BPTree).withConfig({
  displayName: "TreeLegacystyles__TreeLegacy",
  componentId: "sc-146bbz5-0"
})([""]);
export var Styled = {
  TreeLegacy: TreeLegacy
};